<template>
  <div class="container application">
    <h2 v-if="isMonthlySubscribe" class="mt-2">구독 신청이 완료되었습니다.</h2>
    <h2 v-if="!isMonthlySubscribe" class="mt-2">계약이 완료되었습니다.</h2>
    <h3 class="page-title mt-2">축하합니다🎉</h3>
    <h3 v-if="isMonthlySubscribe" class="page-title">{{ userName }} 님의 쏘카플랜 구독 신청이 완료되었습니다.</h3>
    <h3 v-if="!isMonthlySubscribe" class="page-title">{{ userName }} 님의 쏘카플랜 기간형({{ rentMonths }}개월) 계약이 완료되었습니다.</h3>
    <h3 class="page-title">계약서는 이메일로 발송되었으며,</h3>
    <h3 class="page-title">차량 번호는 대여 시작일에 별도 안내될 예정입니다.</h3>
    <div v-if="!isMonthlySubscribe || (isMonthlySubscribe && isMonthlySubscribeCouponTime)" class="mt-2">
      <h3 class="page-title">프로모션 및 특별 혜택 안내</h3>
      <br />
      <h3 class="page-title">프로모션 쿠폰은 차량 인수 이후 쿠폰 코드를 문자로 발송할 예정입니다.</h3>
      <h3 class="page-title">쿠폰 등록 및 사용 전 문자 내 유의사항을 확인해주시기 바랍니다.</h3>
    </div>
    <vs-row class="form-group submit mb-2">
      <vs-col vs-lg="12" vs-sm="12" vs-xs="12" class="bottom-button">
        <button
          type="submit"
          class="btn btn_lg btn_full btn_outline"
          @click.prevent="complete"
        >
          계약 정보 보러가기
        </button>
      </vs-col>
    </vs-row>

    <vs-row class="form-group submit mb-2">
      <vs-col vs-lg="12" vs-sm="12" vs-xs="12" class="bottom-button">
        <button
          type="submit"
          class="btn btn_lg btn_full"
          @click.prevent="next"
        >
          추가 운전자 등록하기
        </button>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import config from 'config';
import * as amplitude from '@amplitude/analytics-browser';
import { postMessageToPlanHome } from 'utils/webview/postMessageToPlanHome';
import { isWebview } from 'utils/webview/isWebview';
import { closeWebView } from 'utils/webview/closeWebView';

export default {
  name: 'Step06',
  components: {},
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    isMonthlySubscribe: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      rentalHistoryUrl: config.rentalHistory.baseURL,
      application: this.data,
      isMonthlySubscribeCouponTime: false,
    };
  },
  computed: {
    userName() {
      return this.$store.state.user.name;
    },
    rentMonths() {
      return this.data.rentMonths;
    },
    carTypeName() {
      return this.data.carTypeName;
    },
  },
  created() {
    const { regionGroup, carType, carTypeId, contractId, prepaidRate } = this.data;
    const eventAndCustomData = {
      page_name: 'plan_contract_5_complete',
      event_label: regionGroup.id || '',
      event_category: document.title,
      page_url: document.URL,
      component_state: prepaidRate === 0 ? '' : `prepayments_${prepaidRate * 100}%`,
      component_type: carType.thumbnailTags.map(({ id }) => id).join(','),
      component_category: carType.carClassTag.id || '',
      component_id: carTypeId,
      service_type: carType.benefitTags.map(({ id }) => id).join(','),
      reservation_id: contractId,
    };
    this.$gtag.event('view', eventAndCustomData);
    amplitude.logEvent('view', eventAndCustomData);
    window.branch.logEvent('CREATED_CONTRACT', { ...eventAndCustomData, event_column: 'created_contract' }, [], 'CREATED_CONTRACT');
    const now = new Date();
    this.isMonthlySubscribeCouponTime = now >= new Date('2024-03-11:15:00:00');
  },
  methods: {
    complete() {
      const { contractId } = this.data;
      const args = {
        page_name: 'plan_car_contract',
        event_category: document.title,
        page_url: document.URL,
        component_name: 'plan_complete_go_contract_info',
        reservation_id: contractId,
      };
      this.$gtag.event('click', args);
      amplitude.logEvent('click', args);

      if (isWebview()) {
        postMessageToPlanHome('/mypage');
        closeWebView();
        return;
      }
      window.location.href = this.rentalHistoryUrl;
    },
    next() {
      const { contractId } = this.data;
      const args = {
        page_name: 'plan_car_contract',
        event_category: document.title,
        page_url: document.URL,
        component_name: 'plan_add_driver_button',
        reservation_id: contractId,
      };
      this.$gtag.event('click', args);
      amplitude.logEvent('click', args);

      this.$emit('next', this.application);
    },
  },
};
</script>

<style lang="scss" scoped>
.mt-8 {
  margin: 80px 0 0 0;
}
</style>
